import { style } from "@mui/system";
import React, { useEffect } from "react";
import { FiDownload, FiFileText } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { Button } from "reactstrap";

function DownloadingPage() {
  const location = useLocation();
  const { reportData } = location.state || {};

  const downloadReport = () => {
    window.print();
  };

  useEffect(() => {
    console.log("report data from download page", reportData);
  }, [reportData]);

  return (

    
    <div className="bg-white w-full h-full">
      <div className="">
        {reportData && (
          <div className="bg-white p-3 text-xs" id="bank-statement-report">
            {/* Header Section */}
            <div className="border border-gray-300 p-3 mb-3">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <div className="bg-green-700 p-1.5 rounded">
                    <FiFileText className="text-white text-sm" />
                  </div>
                  <div>
                    <h2 className="text-base font-bold text-gray-900">
                      Bank Statement Analysis Report
                    </h2>
                    <p className="text-xs text-gray-600 mt-0.5">
                      Transaction ID: {reportData?.txn_id}
                    </p>
                  </div>
                </div>
                <button
                  onClick={downloadReport}
                  type="button"
                  className="bg-green-700 text-white px-3 py-1.5 rounded text-xs font-semibold hover:bg-green-800 print:hidden"
                >
                  Download
                </button>
              </div>

              {/* Statement Period Info */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs">
                <div className="bg-blue-50 p-2 rounded border border-blue-200">
                  <p className="text-xs text-blue-700 font-semibold uppercase mb-0.5">
                    Statement Period
                  </p>
                  <p className="text-xs font-bold text-blue-900 leading-tight">
                    {reportData?.statement_start_date} to{" "}
                    {reportData?.statement_end_date}
                  </p>
                </div>
                <div className="bg-purple-50 p-2 rounded border border-purple-200">
                  <p className="text-xs text-purple-700 font-semibold uppercase mb-0.5">
                    Duration
                  </p>
                  <p className="text-xs font-bold text-purple-900">
                    {reportData?.duration_in_month} Months
                  </p>
                </div>
                <div className="bg-amber-50 p-2 rounded border border-amber-200">
                  <p className="text-xs text-amber-700 font-semibold uppercase mb-0.5">
                    Request ID
                  </p>
                  <p className="text-xs font-bold text-amber-900">
                    {reportData?.request_id}
                  </p>
                </div>
                <div className="bg-green-50 p-2 rounded border border-green-200">
                  <p className="text-xs text-green-700 font-semibold uppercase mb-0.5">
                    Status
                  </p>
                  <p className="text-xs font-bold text-green-900 uppercase">
                    {reportData?.status?.type}
                  </p>
                </div>
              </div>
            </div>

            {/* Customer Information */}
            <div className="border border-gray-300 p-3 mb-3">
              <h3 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-1.5">
                <span className="w-0.5 h-4 bg-green-700 rounded-full"></span>
                Customer Information
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div>
                  <span className="text-xs text-gray-600 uppercase font-semibold block mb-0.5">
                    Account Holder Name
                  </span>
                  <span className="text-xs font-bold text-gray-900">
                    {reportData?.customer_info?.name}
                  </span>
                </div>
                <div>
                  <span className="text-xs text-gray-600 uppercase font-semibold block mb-0.5">
                    Address
                  </span>
                  <span className="text-xs text-gray-900 leading-tight">
                    {reportData?.customer_info?.address}
                  </span>
                </div>
              </div>
            </div>

            {/* Account Details */}
            {reportData?.accounts?.map((account, idx) => (
              <div
                key={idx}
                className="border border-gray-300 p-3 mb-3 break-inside-avoid"
              >
                <h3 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-1.5">
                  <span className="w-0.5 h-4 bg-blue-700 rounded-full"></span>
                  Account Details
                </h3>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-3">
                  <div className="bg-gray-50 p-2 rounded">
                    <span className="text-xs text-gray-600 uppercase font-semibold block mb-0.5">
                      Bank Name
                    </span>
                    <span className="text-xs font-bold text-gray-900">
                      {account.bank}
                    </span>
                  </div>
                  <div className="bg-gray-50 p-2 rounded">
                    <span className="text-xs text-gray-600 uppercase font-semibold block mb-0.5">
                      Account Number
                    </span>
                    <span className="text-xs font-bold text-gray-900">
                      {account.account_number}
                    </span>
                  </div>
                  <div className="bg-gray-50 p-2 rounded">
                    <span className="text-xs text-gray-600 uppercase font-semibold block mb-0.5">
                      Account Type
                    </span>
                    <span className="text-xs font-bold text-gray-900">
                      {account.account_description}
                    </span>
                  </div>
                  <div className="bg-gray-50 p-2 rounded">
                    <span className="text-xs text-gray-600 uppercase font-semibold block mb-0.5">
                      Branch
                    </span>
                    <span className="text-xs text-gray-900">
                      {account.location}
                    </span>
                  </div>
                  <div className="bg-gray-50 p-2 rounded">
                    <span className="text-xs text-gray-600 uppercase font-semibold block mb-0.5">
                      IFSC Code
                    </span>
                    <span className="text-xs font-mono text-gray-900">
                      {account.ifsc_code}
                    </span>
                  </div>
                  <div className="bg-gray-50 p-2 rounded">
                    <span className="text-xs text-gray-600 uppercase font-semibold block mb-0.5">
                      MICR Code
                    </span>
                    <span className="text-xs font-mono text-gray-900">
                      {account.micr_code}
                    </span>
                  </div>
                </div>

                {/* Transactions Table */}
                <div className="mt-3">
                  <h4 className="text-xs font-bold text-gray-900 mb-2 flex items-center gap-1.5">
                    <span className="w-0.5 h-3 bg-indigo-700 rounded-full"></span>
                    Transaction History ({account.transactions?.length})
                  </h4>

                  <div className="overflow-x-auto border border-gray-300 rounded">
                    <table className="w-full text-xs border-collapse">
                      <thead>
                        <tr className="bg-gray-800 text-white">
                          <th className="px-2 py-1.5 text-left font-semibold border-r border-gray-600">
                            Date
                          </th>
                          <th className="px-2 py-1.5 text-left font-semibold border-r border-gray-600">
                            Description
                          </th>
                          <th className="px-2 py-1.5 text-right font-semibold border-r border-gray-600">
                            Debit (₹)
                          </th>
                          <th className="px-2 py-1.5 text-right font-semibold border-r border-gray-600">
                            Credit (₹)
                          </th>
                          <th className="px-2 py-1.5 text-right font-semibold border-r border-gray-600">
                            Balance (₹)
                          </th>
                          <th className="px-2 py-1.5 text-center font-semibold">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {account.transactions?.map((txn, txnIdx) => (
                          <tr
                            key={txnIdx}
                            className={`${
                              txnIdx % 2 === 0 ? "bg-white" : "bg-gray-50"
                            } border-b border-gray-200`}
                          >
                            <td className="px-2 py-1.5 whitespace-nowrap font-medium text-gray-900 border-r border-gray-200">
                              {txn.date}
                            </td>
                            <td className="px-2 py-1.5 text-gray-700 max-w-xs border-r border-gray-200">
                              <div
                                className="truncate text-xs leading-tight"
                                title={txn.narration}
                              >
                                {txn.narration}
                              </div>
                            </td>
                            <td className="px-2 py-1.5 text-right font-semibold border-r border-gray-200">
                              {parseFloat(txn.amount) < 0 ? (
                                <span className="text-red-700">
                                  {Math.abs(parseFloat(txn.amount)).toFixed(2)}
                                </span>
                              ) : (
                                <span className="text-gray-400">-</span>
                              )}
                            </td>
                            <td className="px-2 py-1.5 text-right font-semibold border-r border-gray-200">
                              {parseFloat(txn.amount) > 0 ? (
                                <span className="text-green-700">
                                  {parseFloat(txn.amount).toFixed(2)}
                                </span>
                              ) : (
                                <span className="text-gray-400">-</span>
                              )}
                            </td>
                            <td className="px-2 py-1.5 text-right font-bold text-gray-900 border-r border-gray-200">
                              {parseFloat(txn.balance).toFixed(2)}
                            </td>
                            <td className="px-2 py-1.5 text-center">
                              <span
                                className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-semibold ${
                                  txn.tamper_flag === "GREEN"
                                    ? "bg-green-100 text-green-800"
                                    : "bg-red-100 text-red-800"
                                }`}
                              >
                                {txn.tamper_flag === "GREEN" ? "✓" : "✗"}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ))}

            {/* Tamper Detection Section */}
            {reportData?.tamper_detection_details && (
              <div className="border border-gray-300 p-3 mb-3 break-inside-avoid">
                <h3 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-1.5">
                  <span className="w-0.5 h-4 bg-red-700 rounded-full"></span>
                  Security & Fraud Analysis
                </h3>

                {reportData.tamper_detection_details.map((detail, idx) => (
                  <div
                    key={idx}
                    className="grid grid-cols-1 sm:grid-cols-3 gap-2"
                  >
                    <div className="bg-green-50 p-2 rounded border border-green-200">
                      <span className="text-xs text-green-700 uppercase font-semibold block mb-0.5">
                        PDF Confidence Score
                      </span>
                      <span className="text-lg font-bold text-green-900">
                        {detail.original_pdf_confidence_score}%
                      </span>
                    </div>
                    <div className="bg-blue-50 p-2 rounded border border-blue-200">
                      <span className="text-xs text-blue-700 uppercase font-semibold block mb-0.5">
                        Fraud Analysis Score
                      </span>
                      <span className="text-lg font-bold text-blue-900">
                        {detail.additional_fraud_analysis_score}%
                      </span>
                    </div>
                    <div className="bg-purple-50 p-2 rounded border border-purple-200">
                      <span className="text-xs text-purple-700 uppercase font-semibold block mb-0.5">
                        Tampering Detected
                      </span>
                      <span className="text-lg font-bold text-purple-900">
                        {detail.txn_amt_bal_tampering_detected}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default DownloadingPage;
